Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="form-check checkbox">\n  ';
 var fieldsetLegendIds = ctx.instance.getFieldsetLegendIds ? ctx.instance.getFieldsetLegendIds() : ''; ;
__p += '\n  ';
 var isViewReadContext = ctx.instance.options && (ctx.instance.options.readOnly || ctx.instance.options.pdf); ;
__p += '\n  ';
 var viewAccessibleLabel = isViewReadContext && ctx.instance.getFormattedViewAccessibleLabel ? ctx.instance.getFormattedViewAccessibleLabel() : ''; ;
__p += '\n  ';
 var useAriaLabelOnly = isViewReadContext && viewAccessibleLabel; ;
__p += '\n  ';
 var ariaAttr = useAriaLabelOnly ? 'aria-label' : 'aria-labelledby'; ;
__p += '\n  ';
 var ariaValue = useAriaLabelOnly ? viewAccessibleLabel : ((fieldsetLegendIds ? fieldsetLegendIds + ' ' : '') + 'l-' + ctx.instance.id + '-' + ctx.component.key); ;
__p += '\n  <' +
((__t = (ctx.input.type)) == null ? '' : __t) +
'\n      ref="input"\n      id="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n      ' +
((__t = (ariaAttr)) == null ? '' : __t) +
'="' +
((__t = (ariaValue)) == null ? '' : __t) +
'"\n      ';
 for (var attr in ctx.input.attr) { ;
__p += '\n      ' +
((__t = (attr)) == null ? '' : __t) +
'="' +
((__t = (ctx.input.attr[attr])) == null ? '' : __t) +
'"\n      ';
 } ;
__p += '\n      ';
 if (ctx.checked) { ;
__p += 'checked=true';
 } ;
__p += '\n      aria-required="' +
((__t = (ctx.component.validate.required)) == null ? '' : __t) +
'"\n      ';
 if (ctx.component.description) { ;
__p += '\n      aria-describedby="d-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n      ';
 } ;
__p += '\n      >\n  ';
 if (!ctx.self.labelIsHidden()) { ;
__p += '\n    <label\n      class="' +
((__t = (ctx.input.labelClass)) == null ? '' : __t) +
' form-check-label"\n      for="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n      id="l-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n    >\n       <span>' +
((__t = (ctx.input.label)) == null ? '' : __t) +
'</span>\n       ';
 if (ctx.component.validate && ctx.component.validate.required) { ;
__p += '\n       <span class="required-star" aria-hidden="true">*</span>\n       ';
 } ;
__p += '\n    </label>\n  ';
 } ;
__p += '\n  ';
 if (ctx.component.tooltip) { ;
__p += '\n    <i ref="tooltip" tabindex="0" class="' +
((__t = (ctx.iconClass('question-sign'))) == null ? '' : __t) +
' text-muted" data-tooltip="' +
((__t = (ctx.component.tooltip)) == null ? '' : __t) +
'"></i>\n  ';
 } ;
__p += '\n</div>\n';
 if (ctx.component.description && ctx.instance.noField) { ;
__p += '\n  <div id="d-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'" class="form-text text-muted">' +
((__t = (ctx.t(ctx.component.description, { _userInput: true }))) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
return __p
}